import { MetricEvent, MetricsTransport } from '@prophecy/metrics';

/**
 * Keeps the last N tracked events in memory and exposes them via `window._perfMetrics()`, so you
 * can inspect everything sent through `metrics.track()` this session — not just one journey's
 * deltas (see `window.__journeyDeltas` in `common/metrics/journey/debugConsole.ts`). Only wired in
 * when perf-metrics debugging is on (see `MetricsProvider`); a ring buffer keeps a long SQL IDE
 * session from growing this unbounded.
 */
const BUFFER_LIMIT = 500;

export class DebugEventBufferTransport implements MetricsTransport {
  private buffer: MetricEvent[] = [];

  constructor() {
    window._perfMetrics = Object.assign(() => [...this.buffer], {
      clear: () => {
        this.buffer = [];
      }
    });
  }

  send(event: MetricEvent): Promise<void> {
    this.buffer.push(event);
    if (this.buffer.length > BUFFER_LIMIT) this.buffer.shift();
    return Promise.resolve();
  }

  destroy(): void {
    delete window._perfMetrics;
  }
}

declare global {
  interface Window {
    _perfMetrics?: (() => MetricEvent[]) & { clear: () => void };
  }
}
